<template>
  <div class="container">
    <section class="blog-bottom">
      <BlogCategories gray :categories="categories" />
      <BlogAuthorCard
        v-for="author in authors"
        :key="author.uuid"
        :author="author"
      />
    </section>
  </div>
</template>

<script lang="ts" setup>
import type { StoryblokStory } from 'storyblok-generate-ts'
import type { BlogAuthorStoryblok, BlogCategoryStoryblok, Story } from '@/types'

interface Props {
  authors: StoryblokStory<BlogAuthorStoryblok>[]
  categories: Story<BlogCategoryStoryblok>[]
}

defineProps<Props>()
</script>

<style lang="scss" scoped>
.container {
  --max-width: 660px;
  --container-padding: 20px;
}

.blog-bottom {
  display: grid;
  grid-template-columns: 1fr;
  row-gap: 40px;
  margin-bottom: 56px;

  @media (min-width: $breakpoint-md) {
    row-gap: 80px;
    margin-bottom: 96px;
  }
}
</style>
